import store from '@/store/index.ts';
/**
 * 权限码枚举 - 与后端 PermCode 严格一致
 * 注意：Redmption 和 Darshboard 是后端的拼写，请勿"修正"
 */
export var PermissionCode;
(function (PermissionCode) {
    PermissionCode["Redeem"] = "Redeem";
    PermissionCode["Redemption"] = "Redmption";
    PermissionCode["Dashboard"] = "Darshboard";
    PermissionCode["FulfillmentVoucher"] = "FulfillmentVoucher";
})(PermissionCode || (PermissionCode = {}));
/** 检查当前用户是否拥有指定权限 */
export function hasPermission(code) {
    const codes = store.state.user.permission_codes || [];
    return codes.includes(code);
}
/** 检查当前用户是否拥有任一指定权限 */
export function hasAnyPermission(...codes) {
    const userCodes = store.state.user.permission_codes || [];
    return codes.some((code) => userCodes.includes(code));
}
